import React from "react";
import { cn } from "../../lib/utils";
import { Heading, Kicker, Text } from "./typography";

type SectionProps = React.HTMLAttributes<HTMLElement>;

export const Section = React.forwardRef<HTMLElement, SectionProps>(
  ({ className, ...props }, ref) => (
    <section ref={ref} className={cn("py-20 sm:py-28", className)} {...props} />
  ),
);
Section.displayName = "Section";

type SectionHeaderProps = {
  kicker?: string;
  /** Section label colour: primary (brand) vs accent (secondary emphasis). */
  kickerTone?: "primary" | "accent";
  title: string;
  description?: string;
  center?: boolean;
  onDark?: boolean;
  className?: string;
};

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  kicker,
  kickerTone = "primary",
  title,
  description,
  center = false,
  onDark = false,
  className,
}) => (
  <div
    className={cn("max-w-2xl", center ? "mx-auto text-center" : "", className)}
  >
    {kicker ? (
      <Kicker
        tone={onDark ? "primary" : kickerTone}
        className={onDark ? "ds-kicker-on-dark" : undefined}
      >
        {kicker}
      </Kicker>
    ) : null}
    <Heading
      level={2}
      size="xl"
      className={cn("mt-3", onDark ? "text-background" : "text-foreground")}
    >
      {title}
    </Heading>
    {description ? (
      <Text tone={onDark ? "on-dark" : "muted"} className="mt-4">
        {description}
      </Text>
    ) : null}
  </div>
);
